var indentStyle = {"indentZero":"OFi7x","indentOne":"KLQsq","indentTwo":"lb1-o","indentThree":"V-Tpl","indentFour":"_4go-q","indentFive":"g8HY-","indentSix":"o-ZEP"};

export { indentStyle as i };
//# sourceMappingURL=indentation-51f48b02.js.map
